import type React from "react";
import { type ReactNode, useMemo } from "react";
import { useContextMenu } from "./hooks";
import styles from "./context-menu-button.module.css";

export type ContextMenuButtonProps = {
  children?: ReactNode;
} & React.AllHTMLAttributes<HTMLDivElement>;

export function ContextMenuButton({
  children,
  ...props
}: ContextMenuButtonProps) {
  const { componentVariant, isOpen } = useContextMenu();

  const validateClassName = useMemo(() => {
    if (componentVariant === "secondary" && isOpen) {
      return styles.IsActive;
    }
    return styles.IsClosed;
  }, [componentVariant, isOpen]);

  return (
    <div
      data-active={isOpen}
      className={
        validateClassName
          ? styles.IsActive
          : styles.ContextMenuButtonPersistentActive
      }
      style={{ position: "relative" }}
      {...props}
    >
      {children}
    </div>
  );
}
